import { CommonModule } from '@angular/common';
import { Component, effect, inject, input, output, signal } from '@angular/core';
import { DialogService } from '@vectronic/util';
import { ColorPickerWindowComponent } from './color-picker-window/color-picker-window.component';

@Component({
  selector: 'vectronic-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  imports: [CommonModule],
})
export class ColorPickerComponent {
  initialColor = input<string>();
  color = signal(this.initialColor());
  setColorEffect = effect(() => this.color.set(this.initialColor()));

  colorChanged = output<string>();

  dialogService = inject(DialogService);

  openColorPickerWindow($event: Event) {
    $event.stopPropagation();
    this.dialogService.open(ColorPickerWindowComponent, {
      data: this.color(),
      afterConfirm: (newColor) => {
        this.color.set(newColor);
        this.colorChanged.emit(newColor);
      },
    });
  }
}
